// extracted by mini-css-extract-plugin
export default {"box":"ModalWindow_box__ryTkd","drag-up":"ModalWindow_drag-up__LW8ZH","subtle-pop-up":"ModalWindow_subtle-pop-up__CePxY"};